var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortalSettingsTabIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38978 12.9998C1.48626 12.9966 1.57782 12.9535 1.64499 12.8796L6.89145 7.28377C6.96091 7.20954 7 7.1089 7 7.00397C7 6.89905 6.96091 6.79841 6.89145 6.72418L1.64499 1.1283C1.57651 1.04872 1.48052 1.00241 1.37936 1.00009C1.27812 0.997773 1.18032 1.03962 1.10872 1.11599C1.03712 1.19236 0.997873 1.29666 1.00009 1.40462C1.0023 1.51258 1.04566 1.61491 1.1203 1.68789L6.10442 7.00397L1.1203 12.3201C1.04837 12.3946 1.00789 12.4971 1.00789 12.6041C1.00789 12.711 1.04854 12.8135 1.12046 12.888C1.19239 12.9625 1.28953 13.0029 1.38978 12.9998L1.38978 12.9998Z",
    fill: "#353B3F",
    stroke: "#353B3F",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalSettingsTabIcon);
export default __webpack_public_path__ + "static/media/portalSettingsTabIcon.2a15f54e4efc8f8bc8358caa0ac98413.svg";
export { ForwardRef as ReactComponent };